/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.carcheck,
            url: '/' + 'carCheck',
            cache: false,
            title: 'Zomer/Winter check',
            headerTitle: 'Zomer/Winter check',

            configuratorStepName: ['carcheck'],
            order: 1,
            operations: [''],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/carcheck.html',
                    controller: Controllers.CarCheckController.controllerId + ' as vm'
                }
            },
            showInMenu: true
        }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }

    App.Core.appCore.run(appRun);
}